

<template>
  <div>
    <!--<b-field label="Especialidade" label-position="on-border">-->
    <b-select
      @input="emitSelected()"
      v-model="selected"
      placeholder="Tipo"
      class="is-fullwidth"
    >
      <option value="">Selecione...</option>
      <option v-for="option in options" :value="option.code" :key="option._id">
        {{ option.code }}
      </option>
    </b-select>
    <!--</b-field>-->
  </div>
</template>
<script>
export default {
  name: "SelectCouncil",
  props: ["initialValue", "status"],
  data() {
    return {
      options: [],
      selected: this.initialValue,
    };
  },
  watch: {
    "initialValue._id": function () {
      // watch it
      this.selected = this.initialValue;
    },
  },
  created() {
    this.$http
      .get(`tb_council/${this.status}`, {
        useCache: true,
      })
      .then((response) => (this.options = response.data));
  },
  methods: {
    emitSelected() {
      this.$emit("selectedCouncil", this.selected);
    },
  },
};
</script>